import { gql } from "@apollo/client";

export const FETCH_SETTINGS_DETAILS = gql`
  query FetchSettingsDetails {
    me {
      id
      installationScripts
      featureFlags
      managerUsers {
        id
        email
        isAdmin
      }
    }
    integrationDetails
  }
`;
